import "./style.scss";

import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import React, { FC } from "react";
import IconError from "../../assets/img/icons/payment/error.svg";
import IconSuccess from "../../assets/img/icons/payment/success.svg";
import { ReactComponent as IconBack } from "../../assets/img/icons/icon_arrow-Left.svg";


interface ResultAfterPaymentProps {
    title: string;
    steps: any;
    message: string;
    textBtn?: string;
    pageSucceeded: boolean;
    handlePreviousStep: () => void;
    handleNextStep: () => void;
    isLoading?: boolean;
}

const ResultAfterPayment: FC<ResultAfterPaymentProps> = ({
    title,
    message,
    pageSucceeded,
    steps,
    textBtn,
    handlePreviousStep,
    handleNextStep,
     isLoading = false,
}) => {
    return (
        <div className="ResultAfterPayment w-100 h-100 d-flex flex-column align-items-center justify-content-between">
            <div className="w-100 text-center  d-flex flex-column align-items-center gap-05">
                <img
                    src={pageSucceeded ? IconSuccess : IconError}
                    style={{ width: "15%" }}
                    alt={`status ${pageSucceeded ? "success" : "error"}`}
                />
                <h2 className="title">{title}</h2>
                <div
                    className="message"
                    data-testid="payment-result-message">
                    {message}
                </div>
            </div>

            <div className={`d-flex justify-content-${!pageSucceeded ? "center" : "center"} w-100`}>
                {!steps[0].isCurrent && !pageSucceeded && (
                    <Button
                        label={"Réessayer le paiement"}
                        onClick={() => handlePreviousStep()}
                        style={Button_Style.OUTLINED}
                        data-testid="back-to-payment-button"
                        icon={<IconBack className="PageHeader__icon" fill={"#272f91"} />}
                    />
                )}
                {pageSucceeded && (
                    <Button
                        disabled={isLoading}
                        label={textBtn ? textBtn : "Accéder à mon profil"}
                        onClick={() => handleNextStep()}
                        data-testid="next-page-button"
                    />
                )}
            </div>
        </div>
    );
};
export default ResultAfterPayment;
